import { render, staticRenderFns } from "./SeparateFileListModal.vue?vue&type=template&id=68a928e2&lang=pug"
import script from "./SeparateFileListModal.vue?vue&type=script&lang=ts"
export * from "./SeparateFileListModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports